import PropTypes from 'prop-types'
import BookingDetailsCardAccomodation from '../../../../account/booking-details/booking-details-card/components/BookingDetailsCardAccomodation'
import BookingDetailsCardExtras from '../../../../account/booking-details/booking-details-card/components/BookingDetailsCardExtras'
import BookingDetailsPackage from '../../../../account/booking-details/booking-details-card/components/BookingDetailsPackage'
import BookingDetailsCardFooter from '../../../../account/booking-details/booking-details-card/BookingDetailsCardFooter'
import PaymentSchedule from '../../../../checkout/PaymentSchedule'
import { useIntl } from 'react-intl'
import messages from '../../../../account/booking-details/translations'
import styles from './QuoteIncludesCollapsible.module.scss'

QuoteIncludesCollapsible.propTypes = {
  order: PropTypes.object.isRequired,
  onCouponRemove: PropTypes.func,
  onVoucherAdd: PropTypes.func,
  dueNowData: PropTypes.object,
}

export default function QuoteIncludesCollapsible({
  order,
  onCouponRemove,
  onVoucherAdd,
  dueNowData,
}) {
  const intl = useIntl()
  const {
    currency,
    itemsMandatory,
    itemsMandatoryTotal,
    itemsExtra,
    itemsExtraTotal,
    totalForOptions,
    options,
    appliedCoupon,
    itemsExtraLegend,
  } = order

  return (
    <div className={styles.content}>
      <div className='price-pan'>
        <BookingDetailsCardAccomodation order={order} isCheckout />
        <BookingDetailsPackage order={order} isCheckout />
      </div>

      {!!itemsMandatory?.length && (
        <BookingDetailsCardExtras
          showQuantity
          showPrice
          title={intl.formatMessage(messages.mandatorySurcharges)}
          currency={currency}
          items={itemsMandatory}
          footerTitle={intl.formatMessage(messages.totalPriceForMandatory)}
          totalAmount={itemsMandatoryTotal}
        />
      )}

      {!!itemsExtra?.length && (
        <BookingDetailsCardExtras
          showQuantity
          showPrice
          title={intl.formatMessage(messages.extras)}
          currency={currency}
          items={itemsExtra}
          footerTitle={intl.formatMessage(messages.totalPriceForExtras)}
          totalAmount={itemsExtraTotal}
          itemsExtraLegend={itemsExtraLegend}
        />
      )}

      {!!options?.length && (
        <BookingDetailsCardExtras
          title={intl.formatMessage(messages.options)}
          currency={currency}
          items={options}
          footerTitle={intl.formatMessage(messages.totalPriceForOptions)}
          totalAmount={totalForOptions}
        />
      )}

      {appliedCoupon && (
        <BookingDetailsCardExtras
          title={intl.formatMessage(messages.discount)}
          currency={currency}
          isCoupon
          items={[appliedCoupon]}
          footerTitle={intl.formatMessage(messages.totalPriceForDiscounts)}
          onCouponRemove={onCouponRemove}
        />
      )}

      <BookingDetailsCardFooter
        order={order}
        showCouponForm
        onVoucherAdd={onVoucherAdd}
      />

      <PaymentSchedule
        dueNowData={dueNowData}
        freeCancellationDays={order.freeCancellationDays}
      />
    </div>
  )
}
